import { Route, Routes } from 'react-router-dom';
import { AppLayout } from '@/app/layouts/AppLayout';
import { AccessDeniedPage } from '@/app/pages/AccessDeniedPage';
import { AccessPendingPage } from '@/app/pages/AccessPendingPage';
import { LoginPage } from '@/app/pages/LoginPage';
import { NotFoundPage } from '@/app/pages/NotFoundPage';
import { DashboardPage } from '@/modules/dashboard';
import { NotificationsModule } from '@/modules/notifications';
import { CategoriesPage, CustomFieldsPage } from '@/modules/inventory/pages';
import { routePaths, modulePaths } from '@/routes/paths';
import { moduleRoutes } from '@/routes/moduleRoutes';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { RequireModuleAccess } from '@/shared/components/RequireModuleAccess';

export function AppRouter() {
  return (
    <Routes>
      <Route path={routePaths.login} element={<LoginPage />} />
      <Route path={routePaths.accessPending} element={<AccessPendingPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path={routePaths.accessDenied} element={<AccessDeniedPage />} />
        <Route element={<AppLayout />}>
          <Route
            path={routePaths.home}
            element={
              <RequireModuleAccess moduleId="dashboard">
                <DashboardPage />
              </RequireModuleAccess>
            }
          />
          <Route
            path={`${routePaths.notifications}/*`}
            element={
              <RequireModuleAccess moduleId="dashboard">
                <NotificationsModule />
              </RequireModuleAccess>
            }
          />
          <Route
            path={modulePaths.categories}
            element={
              <RequireModuleAccess moduleId="inventory">
                <CategoriesPage />
              </RequireModuleAccess>
            }
          />
          <Route
            path={modulePaths.customFields}
            element={
              <RequireModuleAccess moduleId="inventory">
                <CustomFieldsPage />
              </RequireModuleAccess>
            }
          />
          {moduleRoutes}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
